// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'location';

export const Component = () => (
  <g
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='1.5'
  >
    <path d='M9.4 7.8c0 1.7 1.4 3.1 3.1 3.1s3.1-1.4 3.1-3.1-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1z' />
    <path d='M12.5.8c3.9 0 7 3.1 7 7 0 3.4-5.3 11-6.7 12.9-.1.2-.4.2-.5.1l-.1-.1c-1.4-1.9-6.7-9.5-6.7-12.9 0-3.9 3.1-7 7-7z' />
    <path d='M18.7 18.5c2.8.6 4.7 1.5 4.7 2.6 0 1.7-4.9 3.1-10.9 3.1S1.6 22.8 1.6 21.1c0-1.1 1.9-2 4.7-2.6' />
  </g>
);

export const viewBox = '0 0 25 25';
